import landingRedirects from './landing-redirects.json';
import exceptionsEnUs from './landing-redirects-exceptions-en-us.json';

const esc = (literal: string) => literal.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
/**
 * Escape all RegExp metacharacters in a literal string.
 */
const pattern = new RegExp(
  Object.keys(landingRedirects)
    .sort((a, b) => b.length - a.length) // longest first
    .map(esc) // escape meta-chars
    .join('|'), // alternation
  'g' // global search
);

// SEO team requested to disabled en-US links for which they do no have redirects
const stripUnsupportedEnUSLinks = (html: string) => {
  const exceptionCheck = (href: string) =>
    exceptionsEnUs?.find((ex) => href.toLowerCase().includes(ex.toLowerCase()));

  // One pass over the HTML string
  return html.replace(
    /<a\b[^>]*\bhref\s*=\s*(?:"([^"]*)"|'([^']*)')[^>]*>([\s\S]*?)<\/a>/gi,
    (fullMatch, hrefDouble, hrefSingle, innerHtml) => {
      const href = hrefDouble || hrefSingle || '';

      // Skip <a> tags that don't target /en-US/
      if (
        !href.includes('/en-US/') ||
        href?.includes('/en-US/subscribe') ||
        exceptionCheck(href)
      )
        return fullMatch;

      return innerHtml;
    }
  );
};

export const replaceLandingRedirects = (txt: string): string => {
  const chunks = txt.split(/(<iframe\b[\s\S]*?<\/iframe>)/gi);

  // avoiding touching iframes
  for (let i = 0; i < chunks.length; i += 2) {
    chunks[i] = chunks[i].replace(pattern, (matched) => {
      return (landingRedirects as { [key: string]: string })[matched];
    });
  }

  // extra replacement for short links
  // done separatly to not mess up longer links that can overlap with large link
  const withLandingAdjusted = chunks
    .join('')
    ?.replaceAll('de-DE/leasing">', 'de-DE/auto/leasing">');

  return stripUnsupportedEnUSLinks(withLandingAdjusted);
};
